import {appStore} from "../store/AppModule";
import { Component, Vue} from "vue-property-decorator";
import http from "../services/Http";
import { FreightCalculationModel, FreightCostResultModel } from "../models/freightCalculation";
import { CheckoutTranslationModel as TranslationModel } from "../models/deliveryModel";


@Component
export default class FreightCalculation extends Vue {
    public $refs!: {
        postNumber: any;
        postCity: any;
        weight: any;
    };
    protected translations: TranslationModel;
    protected vm: any = {};
    private apiUrl: string = "/api/freightcost";
    private infoModel: FreightCalculationModel = {title: "", obsText: "", reservationText: "", currencyCode: "", customerNumber: ""};
    private resultModel: FreightCostResultModel = {freightCostSEK: 0, description: "", freightCalc_WarehouseName: ""};
    private showError: boolean = false;
    private formattedFreight: string = "";
    private isValidPostalNumber: boolean = true;
    private isValidPostalCity: boolean = true;
    private isValidWeight: boolean = true;
    private weightLimitExceeded: boolean = false;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
         this.infoModel.title =  this.$attrs.title;
         this.infoModel.obsText =  this.$attrs.obstext;
         this.infoModel.reservationText =  this.$attrs.reservationtext;
         this.infoModel.currencyCode =  this.$attrs.currencycode;
         this.infoModel.customerNumber = this.$attrs.customernumber;
    }

    protected validatePostalNumber() {
        if (this.$refs.postNumber.value === "") {
            this.isValidPostalNumber = true;
        } else {
            const postNumberRegExp = "^(s-|S-){0,1}[0-9]{3}\s?[0-9]{2}$";
            this.isValidPostalNumber =  this.$refs.postNumber.value !== "" && this.$refs.postCity.value === ""
            && this.$refs.postNumber.value.match(postNumberRegExp) !== null;
         }
    }

    protected validatePostalCity() {
        if (this.$refs.postCity.value === "") {
            this.isValidPostalCity = true;
        } else {
            const postCityRegExp = "^[a-zA-ZäöåÄÖÅ]+$";
            this.isValidPostalCity =  this.$refs.postNumber.value === "" && this.$refs.postCity.value !== "" && this.$refs.postCity.value.match(postCityRegExp) !== null;
        }
    }
    protected validateWeight(event: any) {
        const keyCode = event.keyCode;
        if (keyCode < 48 || keyCode > 57) {
            event.preventDefault();
        }
    }

    private getFreightCost() {
        if (this.$refs.weight.value !== "" && (this.$refs.postNumber.value !== "" || this.$refs.postCity.value !== "")) {
            if (this.$refs.weight.value > 40000) {
                this.weightLimitExceeded = true;
            } else {
                this.weightLimitExceeded = false;
                http.get<FreightCostResultModel>(`${this.apiUrl}?customerNumber=` + this.infoModel.customerNumber + "&grossWeight=" + this.$refs.weight.value + "&zipCode=" + this.$refs.postNumber.value + "&city=" + this.$refs.postCity.value)
                .then(r => {
                    this.resultModel = r;
                    this.formattedFreight = r.freightCostSEK.toLocaleString(appStore.state.culture);
                });
            }
        } else {
            this.showError = true;
        }
    }
}
